import './myWishlist.css';

import ReactLoading from 'react-loading';
import TitleBar from '../../components/titleBar/titleBar';
import TripStrap from '../../components/tripStrap/TripStrap';
import { useEffect, useState } from 'react';
import EmptyPage from '../../components/empty-page/emptyPage';
import myWishlistData, { myWishlistCount } from './myWishlistFun/myWishlistData';
import Pagination from '../../components/pagination/Pagination';
import { fetchWishlistData } from '../../components/tripCard/getUserWishlist/getUserWishlist';
// import { fetchWishlistData, fetchWishlistWithLimit } from '../../components/tripCard/getUserWishlist/getUserWishlist';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ListingCard from './listingCard/ListingCard';
import { delWishFun } from '../../api/userAPI';
import { toast } from 'react-toastify';
import { getType, getTypeOrg, getTypeShort } from '../../utils/getType';
import TripCard from '../../components/tripCard/TripCard';

export default function MyWishlist() {
    const isMobile = window.innerWidth < 768;
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const typeSel = searchParams.get('type') || 'trip';
    const [wishlistData, setWishlistData] = useState([]);
    const [userWishlist, setUserWishlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalData, setTotalData] = useState(0);
    const types = ['trip', 'camp', 'guide', 'activity'];
    const limit = Number(searchParams.get('limit')) || 10;
    const pageNumber = Number(searchParams.get('page')) || 1;
    const offSet = (pageNumber - 1) * limit;
    const typeMap = {
        trip: 'trip',
        guide: 'gu',
        activity: 'act',
        camp: 'camp'
    };

    const name =
        {
            trip: 'Trip',
            activity: 'Activity',
            guide: 'Guide',
            camp: 'Camp',
            ayur: 'Ayurveda'
        }[typeSel] || 'Unknown';

    useEffect(() => {
        const fetchData = async () => {
            try {
                await myWishlistData(typeMap[typeSel], limit, offSet, setWishlistData, setLoading);
            } catch (err) {
                console.log('Failed to fetch search results');
            }
        };

        fetchData();
    }, [typeSel, limit, offSet]);
    useEffect(() => {
        if (!totalData) return;

        const page = Number(searchParams.get('page')) || 1;
        const limitParam = Number(searchParams.get('limit')) || 10;
        const maxPage = Math.ceil(totalData / limitParam);

        if (page > maxPage) {
            setSearchParams({
                page: 1,
                limit: limitParam
            });
        }
    }, [totalData]);

    // useEffect(() => {
    //     fetchWishlistData(typeSel, setUserWishlist);
    // }, [typeSel]);

    useEffect(() => {
        myWishlistCount(typeMap[typeSel], setTotalData);
    }, [typeSel]);

    const handleDelete = async (id) => {
        const data = await delWishFun(typeMap[typeSel], id);

        if (data.status === 200) {
            toast.success(`${name} removed from wishlist`);
            setWishlistData(data.data[typeMap[typeSel]]);

            setTotalData((prev) => prev - 1);
        }
    };

    const handleClick = (id) => {
        navigate(`/${typeMap[typeSel]}/details/${id}`);
    };
    const paginationClick = (page) => {
        if (Math.ceil(totalData / limit) <= 1) return;
        setSearchParams({
            page,
            limit
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleTypeChange = (type) => {
        setSearchParams({
            type,
            page: 1,
            limit
        });
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <TitleBar title='My Wishlist' />
            <div className='customContainer'>
                <div className='wishlistTabsWish'>
                    {types.map((type) => (
                        <button
                            key={type}
                            className={typeSel === type ? 'activeTab' : ''}
                            onClick={() => handleTypeChange(type)}
                        >
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                        </button>
                    ))}
                </div>
                {(!wishlistData || wishlistData.length === 0) && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='packageWrapper'>
                        {/* {wishlistData?.[getTypeShort(typeSel)]?.map((item) => (
                            <ListingCard
                                type={typeSel}
                                title={item?.title}
                                actualPrice={
                                    typeSel === 'trip' ? item?.price?.[0]?.price?.actual : item?.price?.[0]?.actual
                                }
                                where={item?.quickView?.where}
                                duration={item?.quickView?.duration}
                                images={item?.cardImages}
                                rating={item?.organizerId?.rating}
                                reviewCount={item?.organizerId?.reviewCount}
                                _id={item?._id}
                                handleClick={handleClick}
                                handleDelete={handleDelete}
                            />
                        ))} */}
                        <TripCard
                            imageData={wishlistData}
                            type={typeMap[typeSel]}
                            handleDelete={handleDelete}
                            myWishList={true}
                        />
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
            </div>
        </div>
    );
}
